import(/* webpackMode: "eager" */ "/home/runner/work/fynwise/fynwise/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"100\",\"300\",\"400\",\"700\",\"900\"],\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/fynwise/fynwise/src/app/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/fynwise/fynwise/src/app/globals.css");
